export const themeEditorUiConfigMessage = [
  {
    sectionName: "Content Blocks - Message",
    sectionKey: "contentBlocks.message",
    description: "Styling for message content block type",
    groups: [
      {
        groupName: "Common",
        elements: [
          {
            label: "Text Color",
            accessAs: "contentBlocks.message.container.color",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Message default text color",
            options: {
              allowInherit: true,
              modalTitle: "Message Default Text Color",
            },
          },
          {
            label: "Background Color",
            accessAs: "contentBlocks.message.container.background",
            component: "ColorSelector",
            default: "#1e293b",
            description: "Message default background color",
            options: {
              allowInherit: true,
              modalTitle: "Message Default Background Color",
            },
          },
          // {
          //   label: "Font Size",
          //   accessAs: "contentBlocks.message.container.fontSize",
          //   component: "FontSizeSelector",
          //   default: "1.75rem",
          //   allowCustom: true,
          //   description: "Message default font size",
          //   options: {
          //     allowInherit: true,
          //   },
          // },
          {
            label: "Font Weight",
            accessAs: "contentBlocks.message.container.fontWeight",
            component: "FontWeightSelector",
            default: "600",
            description: "Message default font weight",
            options: {
              allowInherit: true,
            },
          },
          {
            label: "Font Family",
            accessAs: "contentBlocks.message.container.fontFamily",
            component: "FontFamilySelector",
            default: "Inter, system-ui, -apple-system, sans-serif",
            allowCustom: true,
            description: "Message default font family",
            options: {
              allowInherit: true,
            },
          },
        ],
      },
    ],
  },
];
